export const EOrdenationType = {
  Crescent: 0,

  Decreasing: 1,
} as const

export type EOrdenationType = (typeof EOrdenationType)[keyof typeof EOrdenationType]
